// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import PageContainer from "../containers/PageContainer";
import AboutMe from "../containers/AboutMe";
import { withTranslation } from 'react-i18next';

class AboutMeView extends Component {
    render() {
        const { t, user, settings } = this.props;

        return (
            <PageContainer title={`${settings.supplierName} ${t("With")} ${user.representative.name}`} showShopToolbar={false}>
                <AboutMe navSection={this.props.match.params.navSection} />
            </PageContainer>

        );
    }
}

function mapStateToProps({ user, settings }, ownProps) {
    return { user, settings, ...ownProps };
}

export default withTranslation()(connect(mapStateToProps, null)(AboutMeView));
